module.exports = __webpack_public_path__ + "assets/retina_CenterOfRotationDetailed.1ddb788b0884f476fbf7e02fe9876178.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CenterOfRotationDetailed.png
// module id = 631
// module chunks = 0